<div class="pageheader">
  <div class="page-title">
    <h1>User role</h1>
  </div>
</div>

<div class="btn-toolbar">
  <button id="btnEdit" class="btn btn-primary btn-sm" (click)="edit()" *bizPermissionRequired="['UserRoles_Action_Edit']" [disabled]="isEditing()">Edit</button>
  <button id="btnDelete" class="btn btn-primary btn-sm" (click)="delete()" *bizPermissionRequired="['UserRoles_Action_Delete']" [disabled]="isEditing()">Delete</button>
  @if (isEditing()) {
  <button [disabled]="!currentRole().RoleName || nameAlreadyExists()" class="btn btn-primary btn-sm" (click)="save()">Save</button>
  <button class="btn btn-link btn-sm" (click)="cancel()">Cancel</button>
  }
</div>

<hr />

<div class="container container-fixed">

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Name</label>
        <input id="roleName" class="form-control" [readonly]="!isEditing()" [ngModel]="currentRole().RoleName" (ngModelChange)="updateRoleName($event)" />
        @if (isEditing() && nameAlreadyExists()) {
        <p class="error">A role with this name already exists.</p>
        }
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Permissions</label>
        <div id="rolePermissions" style="height: auto" class="form-control" readonly>
          <ol>
            @for (item of this.currentRole().Permissions; track $index) {
            <li>{{item.PermissionName}}</li>
            }
          </ol>
        </div>

        <div id="onlySelected" class="control control-checkbox lg control-form-group">
          <label>
            <span>Only selected</span>
            <input type="checkbox" [disabled]="!isEditing()" [(ngModel)]="onlySelected" /><i></i>
          </label>
        </div>

        <dx-data-grid [disabled]="!isEditing()" biz-grid #gridPermissions id="rolePermissionsGrid" [bizSetGroupPanel]="false" [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false"
          [bizSetExport]="false" [bizSetStateStoring]="false" [dataSource]="visiblePermissions()" [selection]="{ mode: 'multiple', allowSelectAll: false }"
          (onSelectionChanged)="selectionChanged($event)">
          <dxi-column dataField="PermissionName" caption="Name" dataType="string" allowEditing="false"></dxi-column>
          <dxi-column dataField="Description" caption="Description" dataType="string" allowEditing="false"></dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      @if (isEditing()) {
      <button class="btn btn-primary" (click)="save()" [disabled]="!currentRole().RoleName || nameAlreadyExists()">Save</button>
      <button class="btn btn-link" (click)="cancel()">Cancel</button>
      }
    </div>
  </div>
</div>
